import { sanitizeInput } from '../config/security';

export const validateImageFile = (file, maxSizeMB = 2) => {
  const errors = [];
  
  if (!file) {
    return { isValid: false, errors: ['Tidak ada file yang dipilih'] };
  }
  
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
  if (!allowedTypes.includes(file.type)) {
    errors.push('Tipe file tidak didukung. Gunakan format JPG, PNG, GIF, atau WebP.');
  }
  
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  if (file.size > maxSizeBytes) {
    errors.push(`Ukuran file terlalu besar. Maksimal ${maxSizeMB}MB. File Anda ${(file.size / (1024 * 1024)).toFixed(2)}MB.`);
  }
  
  return new Promise((resolve) => {
    if (errors.length > 0) {
      resolve({ isValid: false, errors });
      return;
    }
    
    const img = new Image();
    img.onload = () => {
      if (img.width < 100 || img.height < 100) {
        errors.push('Dimensi gambar terlalu kecil. Minimal 100x100 piksel.');
      }
      
      if (img.width > 4000 || img.height > 4000) {
        errors.push('Dimensi gambar terlalu besar. Maksimal 4000x4000 piksel.');
      }
      
      resolve({ 
        isValid: errors.length === 0, 
        errors,
        dimensions: { width: img.width, height: img.height },
        size: file.size,
        type: file.type
      });
    };
    
    img.onerror = () => {
      resolve({ 
        isValid: false, 
        errors: ['File gambar tidak valid atau rusak.'] 
      });
    };
    
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const result = e.target.result;
        if (result && typeof result === 'string' && result.startsWith('data:image/')) {
          const base64Data = result.split(',')[1];
          if (base64Data && /^[A-Za-z0-9+/]*={0,2}$/.test(base64Data)) {
            // Additional validation for data URL length to prevent XSS
            if (result.length > 10 * 1024 * 1024) { // 10MB limit for data URL
              resolve({ 
                isValid: false, 
                errors: ['Data gambar terlalu besar untuk diproses.'] 
              });
              return;
            }
            img.src = result;
          } else {
            resolve({ 
              isValid: false, 
              errors: ['Format data gambar tidak valid.'] 
            });
          }
        } else {
          resolve({ 
            isValid: false, 
            errors: ['Format file gambar tidak valid.'] 
          });
        }
      } catch (error) {
        resolve({ 
          isValid: false, 
          errors: ['Gagal memproses file gambar.'] 
        });
      }
    };
    
    reader.onerror = () => {
      resolve({ 
        isValid: false, 
        errors: ['Gagal membaca file gambar.'] 
      });
    };
    
    reader.readAsDataURL(file);
  });
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const validateFile = (file, allowedTypes = [], maxSize = 5 * 1024 * 1024) => {
  if (!file) return { valid: false, error: 'Tidak ada file yang disediakan' };
  
  if (allowedTypes.length > 0 && !allowedTypes.includes(file.type)) {
    return { valid: false, error: 'Tipe file tidak diizinkan' };
  }
  
  if (file.size > maxSize) {
    return { valid: false, error: 'Ukuran file terlalu besar' };
  }
  
  return { valid: true };
};